// extracted by mini-css-extract-plugin
module.exports = {"WrapperStyled":"Wrapper_WrapperStyled__-MjpT"};